import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import Main from './Main';
import './network/service'; // register axios page-session interceptor at startup
import './helpers/initFA';
import { store, persistor  } from './store';
import { PersistGate } from 'redux-persist/integration/react';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Main>
        <App />
      </Main>
    </PersistGate>
  </Provider>,
  document.getElementById('main')
);
